import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import * as Boleto from 'boleto.js';

@Component({
  selector: 'app-boleto-fisico',
  templateUrl: './boleto-fisico.component.html',
  styleUrls: ['./boleto-fisico.component.scss']
})
export class BoletoFisicoComponent implements OnInit {

  constructor(

  ) { }

  ngOnInit() {
    this.geraCodigDeBarra();
    console.log(this.digitoAutoConferenciaNossoNumero('00000000002', '19'));
  }

  geraCodigDeBarra() {

    const numero = '23793.41502 99081.000186 96003.669205 8 78700000016784';
    new Boleto(numero).toSVG('#boleto');

  }

  digitoAutoConferenciaNossoNumero(nossoNumero: string, carteira: string): string {
    const produto = '2765432765432';
    const valor = carteira + nossoNumero;
    let somatorio = 0;
    for (let i = 0; i < produto.length; i++) {
      somatorio += Number(valor[i]) * Number(produto[i]);
    }
    const restoDivisao = somatorio % 11;
    if (restoDivisao === 1) {
      return 'P';
    } else if (restoDivisao === 0) {
      return '0';
    } else {
      return (11 - restoDivisao).toString();
    }
  }


}
//pagina da composiçao da linha digitavel 29
